// FILE: src/components/DashboardGrid.js
//
// Two-column responsive shell: primary content column on the left,
// sticky coach rail on the right. Collapses to a single stacked
// column under 1024px.

import React from 'react';
import styles from './DashboardGrid.module.css';

export default function DashboardGrid({ primary, rail }) {
  return (
    <div className={styles.grid}>
      <div className={styles.primary}>{primary}</div>
      <div className={styles.rail}>{rail}</div>
    </div>
  );
}
